import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Popup from '../components/popup';

export default class Block05 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.gsap = gsap;

        this.init();
    }

    init () {
        this.gsap.registerPlugin(ScrollTrigger);

        this.popup();
        this.file();

        if (window.innerWidth > 767) {
            this.animation();
        } else {
            this.mobile();
        }
    }

    popup () {
        const trigger = this.el.querySelector('#community-trigger');
        if (!trigger) return;

        const popup = this.el.querySelector('.block-05--popup');
        if (!popup) return;

        const window = popup.querySelector('.site-popup-window');
        const close = popup.querySelector('.site-popup-close');

        new Popup({ popup, toggle: trigger, window, close });
    }

    file () {
        const file = this.el.querySelector('.block-05--form-file input[type="file"]');
        if (!file) return;

        const name = this.el.querySelector('.block-05--form-file-name');
        if (!name) return;

        file.addEventListener('change', () => {
            name.textContent = file.files.length ? file.files[0].name : 'No file chosen';
        });
    }

    animation () {
        const section = this.el.querySelector('[data-animation="community"]');

        const ticker = this.el.querySelector('.block-05--ticker');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const button = this.el.querySelector('.site-button');

        /* Step: Section */

        this.gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: () => 'top top',
                end: () => `+=${window.innerHeight * 1.5}px`,
                pin: true,
                pinSpacing: false,
                scrub: true
            }
        });

        /* Step: Content */

        {
            const timeline = this.gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: () => 'top bottom',
                    end: () => `+=${window.innerHeight * 1.5}px`,
                    scrub: true
                }
            });

            timeline
                .set(ticker, { opacity: 0 })
                .set(text,   { opacity: 0 })
                .set(button, { opacity: 0 })
                .to({},      { duration: 1.5 })
                .to(ticker,  { duration: 2, opacity: 1 })
                .to(text,    { duration: 1, opacity: 1 })
                .to(button,  { duration: 1, opacity: 1 })
                .to({},      { duration: 0.5 });
        }
    }

    mobile () {
        const ticker = this.el.querySelector('.block-05--ticker');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const button = this.el.querySelector('.site-button');
        
        ticker.classList.add('site-animation', 'fade-in');
        text.classList.add('site-animation', 'fade-up');
        button.classList.add('site-animation', 'fade-in');

        [ticker, text, button].forEach((element) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    once: true,
                    onEnter: () => element.classList.add('animated')
                }
            });
        });
    }
}